import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { Suspense } from 'react'
import { ResetPassword } from '@/components/auth/reset-password/reset-password'

const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
  redirect: z.string().optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute('/_auth/reset-password')({
  validateSearch: zodValidator(resetPasswordSearchSchema),
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  return (
    <Suspense
      fallback={
        <div className="md:bg-muted flex items-center justify-center bg-cover md:min-h-screen">
          <div className="flex h-screen w-full flex-col md:h-auto md:max-w-[440px] md:px-4 md:py-6">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground mx-auto mb-4"></div>
              <p>Loading...</p>
            </div>
          </div>
        </div>
      }
    >
      <ResetPassword />
    </Suspense>
  )
}
